function circIn(t) {
  return 1.0 - Math.sqrt(1.0 - t * t)
}

module.exports = circIn


//////////////////
// WEBPACK FOOTER
// ./~/eases/circ-in.js
// module id = 126
// module chunks = 35783957827783 255223432971881